import React, { useState, useEffect } from "react";
import { Container, Button, Row, Col, Alert } from 'design-react-kit';
import { getListaVeicoliAttiviUltimiTreAnni } from "../../services/endpoints";
import { showProgress } from "../../utils/elements";
import * as Constants from '../../utils/constants'
import { isCedutoOltreTreAnniFa } from "../../utils/utilities";

export const SibaTabellaVeicoliAttivi = (props) => {

  const [veicoliAttivi, setVeicoliAttivi] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const loadVeicoliAttivi = async () => {
      let listaVeicoliAttivi = await getListaVeicoliAttiviUltimiTreAnni(props.cf);
      console.log('listaVeicoliAttivi=', listaVeicoliAttivi);
      if (listaVeicoliAttivi === undefined || listaVeicoliAttivi.length === 0) {
        console.log('Lista veicoli attivi è vuota per CF: ', props.cf)
        setLoading(false)
        return
      }

      setVeicoliAttivi(listaVeicoliAttivi) //array di JSON
      setLoading(false)
    }

    loadVeicoliAttivi();
  }, [])

  const handleSubmit = (data) => { props.handleChoice(data) }

  const buildTableRow = (veic, i) => {
    if (isCedutoOltreTreAnniFa(veic)) {
      return <></>
    } else {
      return (
        <tr key={veic.idVeicolo}>
          <td className="align-middle text-center"><strong>{i}</strong></td>
          <td className="align-middle text-center"><strong>{veic.targa}</strong></td>
          <td className="align-middle text-center">dal {veic.dataInizioProprieta} <br />al {veic.dataFineProprieta ? veic.dataFineProprieta : '-'}</td>
          <td className="align-middle text-center">
            <div className="btn-group btn-group-vertical">
              <Button
                className="btn btn-primary my-2"
                size="xs"
                color="primary"
                onClick={() => handleSubmit({ veicolo: veic, choice: Constants.RIM_CHOICE_DETTAGLI_DETTAGLI })}
              > Dettagli veicolo
              </Button>
              <Button
                className="btn btn-primary mb-2"
                size="xs"
                color="primary"
                onClick={() => handleSubmit({ veicolo: veic, choice: Constants.RIM_CHOICE_DETTAGLI_PAGAMENTI })}
              > Elenco pagamenti
              </Button>
            </div>
          </td>
        </tr>
      )
    }
  }

  //START RENDERING
  if (isLoading) { return showProgress() }

  if (veicoliAttivi.length > 0) {
    return (
      <Container className="px-2 my-2" id="veicoliAttivi" tag="section">
        <Alert color="info" >ATTENZIONE: &egrave; possibile visualizzare i veicoli posseduti negli ultimi {Constants.ULTIMI_TRE_ANNI + 1} anni</Alert>
        <table className="table table-striped table-sm">
          <thead className="thead-light">
            <tr>
              <th className="align-middle text-center">#</th>
              <th className="align-middle text-center">Targa</th>
              <th className="align-middle text-center">Di propriet&agrave;</th>
              <th className="align-middle text-center">Visualizza</th>
            </tr>
          </thead>
          <tbody>
            {veicoliAttivi.map((veic, i) => (buildTableRow(veic, ++i)))}
          </tbody>
        </table>
        <Container className="px-2 my-2" id="stepper-nav" tag="div">
          <Row>
            <Col>
              <div className="btn-toolbar justify-content-between" role="toolbar">
                <div className="btn-group mr-2">
                  <Button
                    className="btn btn-outline-primary"
                    icon={false}
                    size="sm"
                    tag='a'
                    href={Constants.URL_TASSAAUTO_SERVIZI_ONLINE}
                    role='button'
                  > {Constants.STR_BUTTON_RESET}
                  </Button>
                  <Button
                    className="btn btn-outline-primary"
                    icon={false}
                    size="sm"
                    tag="button"
                    onClick={props.handleBack}
                  > {Constants.STR_BUTTON_INDIETRO}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    )
  } else {
    return (<Alert color="warning">Nessun veicolo proprietà negli ultimi cinque anni trovato</Alert>)
  }
}

export default SibaTabellaVeicoliAttivi;